const config = {
  GOOGLE_MAP_API: process.env.REACT_APP_GOOGLEMAP_API,
  CLOUDFUNCTION_API: process.env.REACT_APP_CLOUDFUNCTION_API,
  GOOGLE_MAP_KEY: process.env.REACT_APP_GOOGLEMAP_KEY,
  NEWS_LETTER_API: process.env.REACT_APP_NEWSLETTER_API,
};

export default config;
